import React from "react";
import CompanySizeFormContent from "Components/CompanySize/CompanySizeFormContent";
import CompanySizeInfoContent from "Components/CompanySize/CompanySizeInfoContent";
import FormContentWrapper from "Components/FormContentWrapper";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import { updateContact } from "Lib/session-utils";
import { getPageNumber } from "Data";

export default function CompanySizePage() {
  const { setSubmitted } = usePageContextUpdate();

  const {
    updateCompanySize,
    currentFormData: { companySize },
    currentFormData: { companyName },
  } = useFormData();

  const { updateSession, sessionData, contactId } = useSession();

  const handleSubmit = async (data) => {
    updateCompanySize(data);

    if (contactId) {
      await updateContact(contactId, {
        numemployees: data,
      });
    }

    await updateSession({
      current_page: getPageNumber("marketing-channel"),
      responses: {
        ...sessionData?.responses,
        q3_employees: {
          numemployees: data,
        },
      },
    });

    setSubmitted(true);
  };

  return (
    <FormContentWrapper
      infoContent={
        <CompanySizeInfoContent
          heading={`請問  ${companyName || "貴公司"} 目前大約有多少位員工？`}
        />
      }
      formFieldContent={
        <CompanySizeFormContent
          formHeading={"單選題"}
          submitCB={handleSubmit}
          companySize={companySize}
        />
      }
    />
  );
}
